import LegalLayout, { P, H2 } from "./LegalLayout";
import { EnvelopeSimple, Phone, MapPin, Clock } from "@phosphor-icons/react";

export default function Contact() {
  return (
    <LegalLayout title="Contact Us" updated="February 2026">
      <P>We reply to every message. If you're a vendor evaluating Vendorly, a customer with a question about a message you received, or a partner exploring an integration — get in touch below.</P>

      <div className="not-prose mt-8 grid sm:grid-cols-2 gap-4">
        <ContactCard icon={EnvelopeSimple} title="Email" value="vendorlyadmin@gmail.com" href="mailto:vendorlyadmin@gmail.com" />
        <ContactCard icon={Phone} title="Phone / WhatsApp" value="+91 89572 93685" href="tel:+918957293685" />
        <ContactCard icon={MapPin} title="Location" value="India" />
        <ContactCard icon={Clock} title="Response time" value="Within 24 hours (business days)" />
      </div>

      <H2>Support hours</H2>
      <P>Monday to Saturday, 10:00 AM to 8:00 PM IST. Emails outside these hours are answered the next business day.</P>

      <H2>Business enquiries</H2>
      <P>For partnerships, bulk vendor onboarding, or press, please email <a href="mailto:vendorlyadmin@gmail.com" className="text-brand-primary font-semibold">vendorlyadmin@gmail.com</a> with the subject line prefix "[Business]".</P>

      <H2>Escalations</H2>
      <P>If your issue is not resolved within 3 business days by our normal support channel, you can escalate by emailing the same address with subject "[Escalation]" and we will respond within 24 hours.</P>
    </LegalLayout>
  );
}

function ContactCard({ icon: Icon, title, value, href }) {
  const Wrap = href ? "a" : "div";
  const props = href ? { href } : {};
  return (
    <Wrap {...props} className="block bg-white border border-brand-border rounded-2xl p-5 hover:border-brand-primary transition-colors">
      <div className="flex items-center gap-2 text-brand-secondary">
        <Icon size={18} weight="duotone" />
        <span className="text-xs uppercase tracking-[0.2em]">{title}</span>
      </div>
      <div className="mt-2 font-heading text-lg font-semibold text-brand-text">{value}</div>
    </Wrap>
  );
}
